import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import { DatePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormLabel from '@material-ui/core/FormLabel';
import Switch from '@material-ui/core/Switch';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Tooltip from '@material-ui/core/Tooltip';

import {validateForm, blurValidations} from '../Common/formValidator';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

import './style.css';

var moment = require('moment');

class AddEditStaff extends Component {
    constructor(props) {
        super(props);

        this.state = {
            staffId:this.props.props.match.params.id
            ,openModal:false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,editable: (this.props.isAdmin || this.props.loginData.profile.Staff.permission === 1)
            ,somethingWasEdited: false
            ,fetchJobTypes:null
            ,staffData:null
            ,loading:false
            ,addEditTitle:"Novo Funcionário"
            ,staffsId:""
            ,firstName:""
            ,lastName:""
            ,fullName:""
            ,gender:"M"
            ,dateOfBirth:""
            ,idNumber:""
            ,financeNumber:""
            ,socialSecurityNumber:""
            ,iban:""
            ,homePhone:""
            ,cellPhone:""
            ,homeAddress:""
            ,email:""
            ,jobTypes:[]
            ,dateAccepted:""
            ,dateCurrentContractStart:""
            ,dateCurrentContractEnd:""
            ,notes:""
            ,isActive:1
        };
    }

    componentDidMount() {
        const { staffId } = this.state;

        if(staffId==="New"){
            fetch(API + "getjobtypes")
            .then(response => response.json())
            .then(result => this.setState({ fetchJobTypes: result.data }));
        }else{
            const fetches = [
                fetch(API + 'getstaff&getbyid=' + staffId)
                , fetch(API + 'getjobtypes')
            ];
            
            Promise.all(fetches)
            .then(responses => Promise.all(responses.map(r => r.json())))
            .then(result => {
                const staffData = result[0].data;

                if(result === null || result[0].shortmsg === "NOK"){
                    this.props.props.history.push('/Staff');
                    return;
                }

                this.setState({ 
                    staffData
                    , fetchJobTypes: result[1].data
                    , staffsId: staffData.StaffId
                    , firstName: staffData.FirstName
                    , lastName: staffData.LastName
                    , fullName: staffData.FullName
                    , gender: staffData.Gender
                    , dateOfBirth: new Date(staffData.DateBirth).setHours(0, 0, 0, 0)
                    , idNumber: staffData.IdNumber
                    , financeNumber: staffData.FinanceNumber
                    , socialSecurityNumber: staffData.SocialSecurityNumber
                    , iban: staffData.IBAN
                    , homePhone: staffData.HomePhone
                    , cellPhone: staffData.CellPhone
                    , homeAddress: staffData.HomeAddress
                    , email: staffData.Email
                    , jobTypes: staffData.JobTypes.split(",")
                    , dateAccepted: moment(staffData.DateAccepted).format('YYYY-MM-DD')
                    , dateCurrentContractStart: moment(staffData.DateCurrentContractStart).format('YYYY-MM-DD')
                    , dateCurrentContractEnd: moment(staffData.DateCurrentContractEnd).format('YYYY-MM-DD')
                    , notes: staffData.Notes
                    , isActive: staffData.IsActive
                 });
            });
        }
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    handleTitleChange = e => this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });
    handleFieldChange = e => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleSelectChange = e => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleRadioChange = e => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleBirthDateInputChange = value => this.setState({ dateOfBirth: value });
    handleDateAcceptedInputChange = value => this.setState({ dateAccepted: value });
    handleDateCurrentContractStartInputChange = value => this.setState({ dateCurrentContractStart: value });   
    handleDateCurrentContractEndInputChange = value => this.setState({ dateCurrentContractEnd: value });
    

    handleSave = (e) => {
        if(!this.state.somethingWasEdited)
            return;

        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false }) && this.state.jobTypes.length > 0){
            let DEFAULT_QUERY = "savestaff&staffid=" + this.state.staffId + "&staffsid=" + this.state.staffsId + "&firstname=" + this.state.firstName.trim()
                                + "&lastname=" + this.state.lastName.trim() + "&fullname=" + this.state.fullName.trim() + "&gender=" + this.state.gender
                                + "&dateofbirth=" + moment(this.state.dateOfBirth).format('YYYY-MM-DD') + "&idnumber=" + this.state.idNumber + "&financenumber=" + this.state.financeNumber
                                + "&socialsecuritynumber=" + this.state.socialSecurityNumber + "&iban=" + this.state.iban.trim() + "&homephone=" + this.state.homePhone.trim()
                                + "&cellphone=" + this.state.cellPhone.trim() + "&homeaddress=" + this.state.homeAddress.trim() + "&email=" + this.state.email.trim()
                                + "&jobtypes=" + this.state.jobTypes + "&dateaccepted=" + moment(this.state.dateAccepted).format('YYYY-MM-DD') + "&datecurrentcontractstart=" + moment(this.state.dateCurrentContractStart).format('YYYY-MM-DD')
                                + "&datecurrentcontractend=" + moment(this.state.dateCurrentContractEnd).format('YYYY-MM-DD') + "&notes=" + this.state.notes.trim() + "&isactive=" + this.state.isActive
                                + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;


            this.setState({loading:true});
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false })});
        }
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.props.props.history.push('/Staff');
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar este funcionário?")){
            this.setState({loading:true});
            fetch(API + 'deletestaff&staffid=' + this.state.staffId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false });
            });
        }
    }

    renderJobTypeOptions = (e) => {
        const jobTypes = this.state.fetchJobTypes;
        if(jobTypes===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=jobTypes.length;i<n;i++) {
            items.push(<MenuItem value={jobTypes[i].Id}
                                 checked={this.state.jobTypes && this.state.jobTypes.indexOf(jobTypes[i].Id) > -1}
                                 className="insetItem multipleItem"
                                 key={jobTypes[i].Id}>{jobTypes[i].Shortname + " - " + jobTypes[i].Name}</MenuItem>);
        }
        return items;
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { editable, staffId } = this.state;
        const optsJobTypes = this.renderJobTypeOptions()
              , addEditTitle = this.state.staffId > 0 && this.state.staffData!=null ? this.state.staffData.FirstName + " " + this.state.staffData.LastName : this.state.addEditTitle
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div id="addEditStaffPage" ref="editForm" className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1><i className="fa fa-user-md"></i> {addEditTitle}                        
                        { (isAdmin || loginData.profile.Staff.isActive) && 
                            <span className="float-right">
                                <FormControlLabel
                                    label="Ativo"
                                    control={
                                        <Switch
                                            id="isActive"
                                            checked={!!+this.state.isActive}
                                            disabled={!(isAdmin || (loginData.profile.Staff.isActive.permission === 1 && editable))}
                                            onChange={this.handleToggle}
                                            color="primary"/>
                                    }/>
                            </span>
                        }
                        </h1>
                    </div>
                </div>
                { staffId !== "New" && (isAdmin || loginData.profile.Schedules) &&
                    <div className="row">
                        <div className="col-12">
                            <Tooltip
                                title={"Ver Horário de " + this.state.fullName}
                                enterDelay={200}>
                                <span className="float-right"><i className="fa fa-clock"></i> <NavLink to={"/Staff/Schedules/"+this.state.staffId}>Ver Horário</NavLink></span>
                            </Tooltip>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="staffsId"
                                       value={this.state.staffsId}
                                       onChange={this.handleFieldChange}
                                       label="Id Interno"
                                       placeholder="Introduza o Id Interno do funcionário"
                                       disabled={this.props.loginData.AccessLevel >= 1} />
                        </div>
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="firstName"
                                       value={this.state.firstName}
                                       onChange={this.handleFieldChange}
                                       label="Primeiro Nome"
                                       placeholder="Introduza o Primeiro Nome"
                                       disabled={!editable}
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="lastName"
                                       value={this.state.lastName}
                                       onChange={this.handleFieldChange}
                                       label="Último Nome"
                                       placeholder="Introduza o Último Nome"
                                       disabled={!editable}
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="fullName"
                                       value={this.state.fullName}
                                       onChange={this.handleFieldChange}
                                       label="Nome Completo"
                                       placeholder="Introduza o Nome Completo"
                                       disabled={!editable} />
                        </div>
                        <div className="fieldHolder required genderOpt">
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Sexo</FormLabel>
                                <RadioGroup
                                    className="radioButtonHolder"
                                    name="gender"
                                    disabled={!editable}
                                    value={this.state.gender}
                                    onChange={this.handleRadioChange}>
                                    <FormControlLabel
                                        className="radioButton"
                                        value="M"
                                        label="Masculino"
                                        disabled={!editable}
                                        control={<Radio checkedIcon={<i className="fa fa-male selected"></i>} icon={<i className="fa fa-male"></i>} />} />
                                    <FormControlLabel
                                        className="radioButton"
                                        value="F"
                                        label="Feminino"
                                        disabled={!editable}
                                        control={<Radio checkedIcon={<i className="fa fa-female selected"></i>} icon={<i className="fa fa-female"></i>} />} />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div className="fieldHolder">
                            <DatePicker
                                fullWidth
                                id="dateOfBirth"
                                name="dateOfBirth"
                                label="Data de Nascimento"
                                format="DD/MM/YYYY"
                                placeholder="Data de Nascimento"
                                disabled={!editable}
                                value={(this.state.dateOfBirth && moment(this.state.dateOfBirth).format('YYYY-MM-DD')) || ""}
                                locale="pt-PT"
                                onChange={this.handleBirthDateInputChange}
                            />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="homePhone"
                                       value={this.state.homePhone}
                                       onChange={this.handleFieldChange}
                                       label="Número de telefone de casa"
                                       placeholder="Introduza o Número de telefone de casa"
                                       disabled={!editable} />
                        </div>
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="cellPhone"
                                       value={this.state.cellPhone}
                                       onChange={this.handleFieldChange}
                                       label="Número de telemóvel"
                                       placeholder="Introduza o Número de telemóvel"
                                       disabled={!editable}
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder required validEmail">
                            <TextField fullWidth
                                       id="email"
                                       value={this.state.email}
                                       onChange={this.handleFieldChange}
                                       label="Email"
                                       placeholder="Introduza o Email"
                                       disabled={!editable}
                                       data-email-error-message="Este email não está correto."
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="homeAddress"
                                       value={this.state.homeAddress}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       multiline
                                       rows={4}
                                       label="Morada de casa" />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="fieldHolder required selectField">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="jobTypes">Escolha as funções</InputLabel>
                                <Select id="jobTypes"
                                        name="jobTypes"
                                        multiple
                                        value={this.state.jobTypes}
                                        onChange={this.handleSelectChange}
                                        disabled={!editable}
                                        data-empty-error-message="Este campo não pode estar vazio">
                                     {optsJobTypes}
                                </Select>
                            </FormControl>
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="idNumber"
                                       value={this.state.idNumber}
                                       onChange={this.handleFieldChange}
                                       label="Número Cartão de Cidadão"
                                       placeholder="Introduza o Número Cartão de Cidadão"
                                       disabled={!editable} />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="financeNumber"
                                       value={this.state.financeNumber}
                                       onChange={this.handleFieldChange}
                                       label="Número de Identificação Fiscal"
                                       placeholder="Introduza o Número de Identificação Fiscal"
                                       disabled={!editable} />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="socialSecurityNumber"
                                       value={this.state.socialSecurityNumber}
                                       onChange={this.handleFieldChange}
                                       label="Número de Segurança Social"
                                       placeholder="Introduza o Número de Segurança Social"
                                       disabled={!editable} />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="iban"
                                       value={this.state.iban}
                                       onChange={this.handleFieldChange}
                                       label="Número de IBAN"
                                       placeholder="Introduza o Número de Identificação Bancária"
                                       disabled={!editable} />
                        </div>
                        <div className="fieldHolder">
                            <DatePicker
                                fullWidth
                                id="dateAccepted"
                                name="dateAccepted"
                                label="Data em que se juntou à empresa"
                                placeholder="Data em que se juntou à empresa"
                                format="DD/MM/YYYY"
                                disabled={!editable}
                                value={(this.state.dateAccepted && moment(this.state.dateAccepted).format('YYYY-MM-DD')) || ""}
                                locale="pt-PT"
                                onChange={this.handleDateAcceptedInputChange}
                            />
                        </div>
                        <div className="fieldHolder">
                            <DatePicker
                                fullWidth
                                id="dateCurrentContractStart"
                                name="dateCurrentContractStart"
                                label="Data de começo do contrato corrente"
                                placeholder="Data de começo do contrato corrente"
                                format="DD/MM/YYYY"
                                disabled={!editable}
                                value={(this.state.dateCurrentContractStart && moment(this.state.dateCurrentContractStart).format('YYYY-MM-DD')) || ""}
                                locale="pt-PT"
                                onChange={this.handleDateCurrentContractStartInputChange}
                            />
                        </div>
                        <div className="fieldHolder">
                            <DatePicker
                                fullWidth
                                id="dateCurrentContractEnd"
                                name="dateCurrentContractEnd"
                                label="Data de fim do contrato corrente"
                                placeholder="Data de fim do contrato corrente"
                                format="DD/MM/YYYY"
                                disabled={!editable}
                                value={(this.state.dateCurrentContractEnd && moment(this.state.dateCurrentContractEnd).format('YYYY-MM-DD')) || ""}
                                locale="pt-PT"
                                onChange={this.handleDateCurrentContractEndInputChange}
                            />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="notes"
                                       value={this.state.notes}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       multiline
                                       rows={4}
                                       label="Observações" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                        { (isAdmin || loginData.profile.Staff.DEL) && this.state.staffId !== "New" && <Button onClick={this.handleDelete} className="button button-danger" variant="contained">Apagar Funcionário</Button>}
                        { editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AddEditStaff;
